/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Core.WebAPI, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetApiOrdersSearchParams,
  Order,
  PostApiOrdersTransferParams,
  SetEstimateRatePeriodDto,
  SetLabourRateSetDto,
} from '.././schemas';

import { apiClient } from '../../../http-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getApiOrdersOrderId = (
  orderId: string,
  options?: SecondParameter<typeof apiClient>,
  signal?: AbortSignal,
) => {
  return apiClient<void>({ url: `/api/Orders/${orderId}`, method: 'GET', signal }, options);
};

export const getGetApiOrdersOrderIdQueryKey = (orderId?: string) => {
  return [`/api/Orders/${orderId}`] as const;
};

export const getGetApiOrdersOrderIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOrdersOrderId>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderId>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOrdersOrderIdQueryKey(orderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOrdersOrderId>>> = ({ signal }) =>
    getApiOrdersOrderId(orderId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orderId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOrdersOrderId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOrdersOrderIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOrdersOrderId>>
>;
export type GetApiOrdersOrderIdQueryError = unknown;

export function useGetApiOrdersOrderId<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderId>>,
  TError = unknown,
>(
  orderId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOrdersOrderId>>,
          TError,
          Awaited<ReturnType<typeof getApiOrdersOrderId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOrdersOrderId<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderId>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOrdersOrderId>>,
          TError,
          Awaited<ReturnType<typeof getApiOrdersOrderId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOrdersOrderId<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderId>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderId>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiOrdersOrderId<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderId>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderId>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOrdersOrderIdQueryOptions(orderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteApiOrdersOrderId = (
  orderId: string,
  options?: SecondParameter<typeof apiClient>,
) => {
  return apiClient<void>({ url: `/api/Orders/${orderId}`, method: 'DELETE' }, options);
};

export const getDeleteApiOrdersOrderIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiOrdersOrderId>>,
    TError,
    { orderId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiOrdersOrderId>>,
  TError,
  { orderId: string },
  TContext
> => {
  const mutationKey = ['deleteApiOrdersOrderId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiOrdersOrderId>>,
    { orderId: string }
  > = (props) => {
    const { orderId } = props ?? {};

    return deleteApiOrdersOrderId(orderId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiOrdersOrderIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiOrdersOrderId>>
>;

export type DeleteApiOrdersOrderIdMutationError = unknown;

export const useDeleteApiOrdersOrderId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiOrdersOrderId>>,
      TError,
      { orderId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiOrdersOrderId>>,
  TError,
  { orderId: string },
  TContext
> => {
  const mutationOptions = getDeleteApiOrdersOrderIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiOrdersOrderIdOrdernumber = (
  orderId: string,
  options?: SecondParameter<typeof apiClient>,
  signal?: AbortSignal,
) => {
  return apiClient<void>(
    { url: `/api/Orders/${orderId}/ordernumber`, method: 'GET', signal },
    options,
  );
};

export const getGetApiOrdersOrderIdOrdernumberQueryKey = (orderId?: string) => {
  return [`/api/Orders/${orderId}/ordernumber`] as const;
};

export const getGetApiOrdersOrderIdOrdernumberQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOrdersOrderIdOrdernumberQueryKey(orderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>> = ({
    signal,
  }) => getApiOrdersOrderIdOrdernumber(orderId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orderId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOrdersOrderIdOrdernumberQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>
>;
export type GetApiOrdersOrderIdOrdernumberQueryError = unknown;

export function useGetApiOrdersOrderIdOrdernumber<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>,
  TError = unknown,
>(
  orderId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>,
          TError,
          Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOrdersOrderIdOrdernumber<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>,
          TError,
          Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOrdersOrderIdOrdernumber<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiOrdersOrderIdOrdernumber<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderIdOrdernumber>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOrdersOrderIdOrdernumberQueryOptions(orderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiOrdersSearch = (
  params?: GetApiOrdersSearchParams,
  options?: SecondParameter<typeof apiClient>,
  signal?: AbortSignal,
) => {
  return apiClient<void>({ url: `/api/Orders/search`, method: 'GET', params, signal }, options);
};

export const getGetApiOrdersSearchQueryKey = (params?: GetApiOrdersSearchParams) => {
  return [`/api/Orders/search`, ...(params ? [params] : [])] as const;
};

export const getGetApiOrdersSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOrdersSearch>>,
  TError = unknown,
>(
  params?: GetApiOrdersSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersSearch>>, TError, TData>>;
    request?: SecondParameter<typeof apiClient>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOrdersSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOrdersSearch>>> = ({ signal }) =>
    getApiOrdersSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOrdersSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOrdersSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOrdersSearch>>
>;
export type GetApiOrdersSearchQueryError = unknown;

export function useGetApiOrdersSearch<
  TData = Awaited<ReturnType<typeof getApiOrdersSearch>>,
  TError = unknown,
>(
  params: undefined | GetApiOrdersSearchParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersSearch>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOrdersSearch>>,
          TError,
          Awaited<ReturnType<typeof getApiOrdersSearch>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOrdersSearch<
  TData = Awaited<ReturnType<typeof getApiOrdersSearch>>,
  TError = unknown,
>(
  params?: GetApiOrdersSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersSearch>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOrdersSearch>>,
          TError,
          Awaited<ReturnType<typeof getApiOrdersSearch>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOrdersSearch<
  TData = Awaited<ReturnType<typeof getApiOrdersSearch>>,
  TError = unknown,
>(
  params?: GetApiOrdersSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersSearch>>, TError, TData>>;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiOrdersSearch<
  TData = Awaited<ReturnType<typeof getApiOrdersSearch>>,
  TError = unknown,
>(
  params?: GetApiOrdersSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersSearch>>, TError, TData>>;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOrdersSearchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiOrders = (
  order: NonReadonly<Order>,
  options?: SecondParameter<typeof apiClient>,
  signal?: AbortSignal,
) => {
  return apiClient<void>(
    {
      url: `/api/Orders`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json;odata.metadata=minimal;odata.streaming=true' },
      data: order,
      signal,
    },
    options,
  );
};

export const getPostApiOrdersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOrders>>,
    TError,
    { data: NonReadonly<Order> },
    TContext
  >;
  request?: SecondParameter<typeof apiClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOrders>>,
  TError,
  { data: NonReadonly<Order> },
  TContext
> => {
  const mutationKey = ['postApiOrders'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiOrders>>,
    { data: NonReadonly<Order> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiOrders(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOrders>>>;
export type PostApiOrdersMutationBody = NonReadonly<Order>;
export type PostApiOrdersMutationError = unknown;

export const usePostApiOrders = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiOrders>>,
      TError,
      { data: NonReadonly<Order> },
      TContext
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiOrders>>,
  TError,
  { data: NonReadonly<Order> },
  TContext
> => {
  const mutationOptions = getPostApiOrdersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const putApiOrders = (
  order: NonReadonly<Order>,
  options?: SecondParameter<typeof apiClient>,
) => {
  return apiClient<void>(
    {
      url: `/api/Orders`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json;odata.metadata=minimal;odata.streaming=true' },
      data: order,
    },
    options,
  );
};

export const getPutApiOrdersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiOrders>>,
    TError,
    { data: NonReadonly<Order> },
    TContext
  >;
  request?: SecondParameter<typeof apiClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiOrders>>,
  TError,
  { data: NonReadonly<Order> },
  TContext
> => {
  const mutationKey = ['putApiOrders'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiOrders>>,
    { data: NonReadonly<Order> }
  > = (props) => {
    const { data } = props ?? {};

    return putApiOrders(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof putApiOrders>>>;
export type PutApiOrdersMutationBody = NonReadonly<Order>;
export type PutApiOrdersMutationError = unknown;

export const usePutApiOrders = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiOrders>>,
      TError,
      { data: NonReadonly<Order> },
      TContext
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiOrders>>,
  TError,
  { data: NonReadonly<Order> },
  TContext
> => {
  const mutationOptions = getPutApiOrdersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiOrdersStatusesEventId = (
  eventId: string,
  options?: SecondParameter<typeof apiClient>,
  signal?: AbortSignal,
) => {
  return apiClient<void>(
    { url: `/api/Orders/statuses/${eventId}`, method: 'GET', signal },
    options,
  );
};

export const getGetApiOrdersStatusesEventIdQueryKey = (eventId?: string) => {
  return [`/api/Orders/statuses/${eventId}`] as const;
};

export const getGetApiOrdersStatusesEventIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOrdersStatusesEventIdQueryKey(eventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>> = ({
    signal,
  }) => getApiOrdersStatusesEventId(eventId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!eventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOrdersStatusesEventIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>
>;
export type GetApiOrdersStatusesEventIdQueryError = unknown;

export function useGetApiOrdersStatusesEventId<
  TData = Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>,
  TError = unknown,
>(
  eventId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>,
          TError,
          Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOrdersStatusesEventId<
  TData = Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>,
          TError,
          Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOrdersStatusesEventId<
  TData = Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiOrdersStatusesEventId<
  TData = Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersStatusesEventId>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOrdersStatusesEventIdQueryOptions(eventId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiOrdersTransfer = (
  postApiOrdersTransferBody: string[],
  params?: PostApiOrdersTransferParams,
  options?: SecondParameter<typeof apiClient>,
  signal?: AbortSignal,
) => {
  return apiClient<void>(
    {
      url: `/api/Orders/transfer`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json;odata.metadata=minimal;odata.streaming=true' },
      data: postApiOrdersTransferBody,
      params,
      signal,
    },
    options,
  );
};

export const getPostApiOrdersTransferMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOrdersTransfer>>,
    TError,
    { data: string[]; params?: PostApiOrdersTransferParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOrdersTransfer>>,
  TError,
  { data: string[]; params?: PostApiOrdersTransferParams },
  TContext
> => {
  const mutationKey = ['postApiOrdersTransfer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiOrdersTransfer>>,
    { data: string[]; params?: PostApiOrdersTransferParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiOrdersTransfer(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiOrdersTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiOrdersTransfer>>
>;
export type PostApiOrdersTransferMutationBody = string[];
export type PostApiOrdersTransferMutationError = unknown;

export const usePostApiOrdersTransfer = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiOrdersTransfer>>,
      TError,
      { data: string[]; params?: PostApiOrdersTransferParams },
      TContext
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiOrdersTransfer>>,
  TError,
  { data: string[]; params?: PostApiOrdersTransferParams },
  TContext
> => {
  const mutationOptions = getPostApiOrdersTransferMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiOrdersWorkpackagesWorkPackageId = (
  workPackageId: string,
  postApiOrdersWorkpackagesWorkPackageIdBody: string[],
  options?: SecondParameter<typeof apiClient>,
  signal?: AbortSignal,
) => {
  return apiClient<void>(
    {
      url: `/api/Orders/workpackages/${workPackageId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json;odata.metadata=minimal;odata.streaming=true' },
      data: postApiOrdersWorkpackagesWorkPackageIdBody,
      signal,
    },
    options,
  );
};

export const getPostApiOrdersWorkpackagesWorkPackageIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOrdersWorkpackagesWorkPackageId>>,
    TError,
    { workPackageId: string; data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOrdersWorkpackagesWorkPackageId>>,
  TError,
  { workPackageId: string; data: string[] },
  TContext
> => {
  const mutationKey = ['postApiOrdersWorkpackagesWorkPackageId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiOrdersWorkpackagesWorkPackageId>>,
    { workPackageId: string; data: string[] }
  > = (props) => {
    const { workPackageId, data } = props ?? {};

    return postApiOrdersWorkpackagesWorkPackageId(workPackageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiOrdersWorkpackagesWorkPackageIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiOrdersWorkpackagesWorkPackageId>>
>;
export type PostApiOrdersWorkpackagesWorkPackageIdMutationBody = string[];
export type PostApiOrdersWorkpackagesWorkPackageIdMutationError = unknown;

export const usePostApiOrdersWorkpackagesWorkPackageId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiOrdersWorkpackagesWorkPackageId>>,
      TError,
      { workPackageId: string; data: string[] },
      TContext
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiOrdersWorkpackagesWorkPackageId>>,
  TError,
  { workPackageId: string; data: string[] },
  TContext
> => {
  const mutationOptions = getPostApiOrdersWorkpackagesWorkPackageIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiOrdersOrderIdHistory = (
  orderId: string,
  options?: SecondParameter<typeof apiClient>,
  signal?: AbortSignal,
) => {
  return apiClient<void>({ url: `/api/Orders/${orderId}/history`, method: 'GET', signal }, options);
};

export const getGetApiOrdersOrderIdHistoryQueryKey = (orderId?: string) => {
  return [`/api/Orders/${orderId}/history`] as const;
};

export const getGetApiOrdersOrderIdHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOrdersOrderIdHistoryQueryKey(orderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>> = ({
    signal,
  }) => getApiOrdersOrderIdHistory(orderId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orderId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOrdersOrderIdHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>
>;
export type GetApiOrdersOrderIdHistoryQueryError = unknown;

export function useGetApiOrdersOrderIdHistory<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>,
  TError = unknown,
>(
  orderId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOrdersOrderIdHistory<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOrdersOrderIdHistory<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiOrdersOrderIdHistory<
  TData = Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiOrdersOrderIdHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOrdersOrderIdHistoryQueryOptions(orderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const patchApiSapOrdersOrderIdLabourRateSet = (
  orderId: string,
  setLabourRateSetDto: SetLabourRateSetDto,
  options?: SecondParameter<typeof apiClient>,
) => {
  return apiClient<void>(
    {
      url: `/api/SapOrders/${orderId}/LabourRateSet`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json;odata.metadata=minimal;odata.streaming=true' },
      data: setLabourRateSetDto,
    },
    options,
  );
};

export const getPatchApiSapOrdersOrderIdLabourRateSetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchApiSapOrdersOrderIdLabourRateSet>>,
    TError,
    { orderId: string; data: SetLabourRateSetDto },
    TContext
  >;
  request?: SecondParameter<typeof apiClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchApiSapOrdersOrderIdLabourRateSet>>,
  TError,
  { orderId: string; data: SetLabourRateSetDto },
  TContext
> => {
  const mutationKey = ['patchApiSapOrdersOrderIdLabourRateSet'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchApiSapOrdersOrderIdLabourRateSet>>,
    { orderId: string; data: SetLabourRateSetDto }
  > = (props) => {
    const { orderId, data } = props ?? {};

    return patchApiSapOrdersOrderIdLabourRateSet(orderId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchApiSapOrdersOrderIdLabourRateSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchApiSapOrdersOrderIdLabourRateSet>>
>;
export type PatchApiSapOrdersOrderIdLabourRateSetMutationBody = SetLabourRateSetDto;
export type PatchApiSapOrdersOrderIdLabourRateSetMutationError = unknown;

export const usePatchApiSapOrdersOrderIdLabourRateSet = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchApiSapOrdersOrderIdLabourRateSet>>,
      TError,
      { orderId: string; data: SetLabourRateSetDto },
      TContext
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchApiSapOrdersOrderIdLabourRateSet>>,
  TError,
  { orderId: string; data: SetLabourRateSetDto },
  TContext
> => {
  const mutationOptions = getPatchApiSapOrdersOrderIdLabourRateSetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const patchApiSapOrdersOrderIdEstimateRatePeriod = (
  orderId: string,
  setEstimateRatePeriodDto: SetEstimateRatePeriodDto,
  options?: SecondParameter<typeof apiClient>,
) => {
  return apiClient<void>(
    {
      url: `/api/SapOrders/${orderId}/EstimateRatePeriod`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json;odata.metadata=minimal;odata.streaming=true' },
      data: setEstimateRatePeriodDto,
    },
    options,
  );
};

export const getPatchApiSapOrdersOrderIdEstimateRatePeriodMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchApiSapOrdersOrderIdEstimateRatePeriod>>,
    TError,
    { orderId: string; data: SetEstimateRatePeriodDto },
    TContext
  >;
  request?: SecondParameter<typeof apiClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchApiSapOrdersOrderIdEstimateRatePeriod>>,
  TError,
  { orderId: string; data: SetEstimateRatePeriodDto },
  TContext
> => {
  const mutationKey = ['patchApiSapOrdersOrderIdEstimateRatePeriod'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchApiSapOrdersOrderIdEstimateRatePeriod>>,
    { orderId: string; data: SetEstimateRatePeriodDto }
  > = (props) => {
    const { orderId, data } = props ?? {};

    return patchApiSapOrdersOrderIdEstimateRatePeriod(orderId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchApiSapOrdersOrderIdEstimateRatePeriodMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchApiSapOrdersOrderIdEstimateRatePeriod>>
>;
export type PatchApiSapOrdersOrderIdEstimateRatePeriodMutationBody = SetEstimateRatePeriodDto;
export type PatchApiSapOrdersOrderIdEstimateRatePeriodMutationError = unknown;

export const usePatchApiSapOrdersOrderIdEstimateRatePeriod = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchApiSapOrdersOrderIdEstimateRatePeriod>>,
      TError,
      { orderId: string; data: SetEstimateRatePeriodDto },
      TContext
    >;
    request?: SecondParameter<typeof apiClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchApiSapOrdersOrderIdEstimateRatePeriod>>,
  TError,
  { orderId: string; data: SetEstimateRatePeriodDto },
  TContext
> => {
  const mutationOptions = getPatchApiSapOrdersOrderIdEstimateRatePeriodMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
